<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('signAccount.queryCondition') }}</span>
      </div>
      <div class="text item">
        <el-form :inline="true" :model="signAccountInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="signAccountInfo.conditions.personName"
              :placeholder="$t('signAccount.placeholder.personName')" clearable />
          </el-form-item>
          <el-form-item>
            <el-input v-model="signAccountInfo.conditions.personId"
              :placeholder="$t('signAccount.placeholder.personId')" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_querySignAccountMethod">
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('signAccount.title') }}</span>
      </div>
      <div class="text item">
        <el-table :data="signAccountInfo.signAccounts" border style="width: 100%">
          <el-table-column prop="accountId" :label="$t('signAccount.table.accountId')" align="center" />
          <el-table-column prop="personId" :label="$t('signAccount.table.personId')" align="center" />
          <el-table-column prop="personName" :label="$t('signAccount.table.personName')" align="center" />
          <el-table-column prop="totalDays" :label="$t('signAccount.table.totalDays')" align="center" />
          <el-table-column prop="continueDays" :label="$t('signAccount.table.continueDays')" align="center" />
          <el-table-column prop="lastSignDate" :label="$t('signAccount.table.lastSignDate')" align="center" />
          <el-table-column prop="cycleNum" :label="$t('signAccount.table.cycleNum')" align="center" />
          <el-table-column prop="createTime" :label="$t('signAccount.table.createTime')" align="center" />
        </el-table>

        <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
          :total="total" layout="total, prev, pager, next" style="margin-top: 20px;" />
      </div>
    </el-card>
  </div>
</template>

<script>
import { querySignAccount } from '@/api/admin/sign/signAccountApi'

export default {
  name: 'SignAccount',
  data() {
    return {
      signAccountInfo: {
        signAccounts: [],
        total: 0,
        records: 1,
        conditions: {
          personName: '',
          personId: '',
          statusCd: '0'
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    total() {
      return this.signAccountInfo.total
    }
  },
  created() {
    this._listSignAccounts(this.currentPage, this.pageSize)
  },
  methods: {
    querySignAccount() {
      this._listSignAccounts(1, 10)
    },
    async _listSignAccounts(page, rows) {
      try {
        const params = {
          ...this.signAccountInfo.conditions,
          page,
          row: rows
        }
        const res = await querySignAccount(params)
        this.signAccountInfo.signAccounts = res.data || []
        this.signAccountInfo.total = res.total || 0
        this.signAccountInfo.records = res.records || 0
      } catch (error) {
        console.error(error)
      }
    },
    _querySignAccountMethod() {
      this.currentPage = 1
      this._listSignAccounts(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listSignAccounts(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
